// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui-helper-clearfix {
  background-color: #00376F;
  width: 376px;
  height: 126px;
  flex-shrink: 0;
}

.identy-review-dialog {
  height: 100vh !important;
  background-color: #00376F;
  width: 100% !important;
  position: relative;
  top: -826px !important;
  left: 0px !important;
}

.ui-dialog-titlebar-close {
  display: none;
}

.identy_next_card_face_dialog {
  text-align: center;
  z-index: 9999;
  width: auto !important;
  min-height: 150px !important;
  max-height: none !important;
  height: 15vh !important;
  padding: 30px;
  background: #00376F;
}
.identy_next_card_face_dialog > h6 {
  color: var(--escala-de-grises-gris-0, #FFF);
  text-align: center;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px; /* 133.333% */
}
.identy_next_card_face_dialog > div {
  display: none;
}
.identy_next_card_face_dialog > div > img {
  display: none;
}
.identy_next_card_face_dialog > div > img :before {
  content: "Look at this orange box.";
  background-color: #ffba10;
  border-color: black;
  border-style: dotted;
}

.ui-dialog-buttonset {
  padding-left: 16px;
  padding-right: 16px;
}
.ui-dialog-buttonset #btnIdentyAccept {
  padding: 16px;
  color: var(--color-enabled-btn);
  background-color: var(--bg-color-enabled-btn);
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: row;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/infraestructure/pages/proof-address-condition/style.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;AACJ;;AAEA;EACI,wBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;AACJ;AAAI;EACI,2CAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;AAER;AAAI;EACI,aAAA;AAER;AADQ;EACI,aAAA;AAGZ;AAFY;EACI,mCAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;AAIhB;;AAEA;EACI,kBAAA;EACA,mBAAA;AACJ;AAAI;EACI,aAAA;EACA,+BAAA;EACA,6CAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAER","sourcesContent":[".ui-helper-clearfix{\n    background-color: #00376F;\n    width: 376px;\n    height: 126px;\n    flex-shrink: 0;\n}\n\n.identy-review-dialog{\n    height: 100vh !important;\n    background-color: #00376F;\n    width: 100% !important;\n    position: relative;\n    top: -826px !important;\n    left: 0px !important;\n}\n\n.ui-dialog-titlebar-close {\n    display: none;\n}\n\n.identy_next_card_face_dialog{\n    text-align: center;\n    z-index: 9999;\n    width: auto !important;\n    min-height: 150px !important;\n    max-height: none !important;\n    height: 15vh !important; \n    padding: 30px;\n    background: #00376F;\n    > h6 {\n        color: var(--escala-de-grises-gris-0, #FFF);\n        text-align: center;\n        font-family: Roboto;\n        font-size: 24px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 32px; /* 133.333% */\n    }\n    > div {\n        display: none;\n        > img {\n            display: none;\n            :before {\n                content: \"Look at this orange box.\";\n                background-color: #ffba10;\n                border-color: black;\n                border-style: dotted;\n              }\n        }\n    }\n    \n}\n.ui-dialog-buttonset {\n    padding-left: 16px;\n    padding-right: 16px;\n    #btnIdentyAccept {\n        padding: 16px;\n        color: var(--color-enabled-btn);\n        background-color: var(--bg-color-enabled-btn);\n        text-align: center;\n        align-items: center;\n        justify-content: center;\n        display: flex;\n        flex-direction: row;\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
